import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
  Text,
} from "@clipboard-health/ui-components";

import { type Worker } from "../Worker/api/types";
import { useSkillsAssessmentFeatureFlags } from "./api/useSkillsAssessmentFeatureFlags";
import { useSkillsAssessments } from "./api/useSkillsAssessments";

interface Props {
  worker: Worker;
  onClick: () => void;
}
export function SkillsAssessmentAccountMenuItem(props: Props) {
  const { onClick, worker } = props;
  const { userId } = worker;

  const { skillsAssessmentConfig, isClipboardOrientationEnabled } =
    useSkillsAssessmentFeatureFlags();
  const { data: skillsAssessments, isSuccess: isSuccessSkillsAssessments } = useSkillsAssessments(
    {
      workerId: userId,
      qualificationNames: skillsAssessmentConfig.availableQualificationNames,
    },
    { staleTime: 0 }
  );

  if (!isSuccessSkillsAssessments || skillsAssessments.data.length === 0) {
    return null;
  }

  return (
    <>
      <Divider />
      <ListItem>
        <ListItemButton hideCallToActionIcon onClick={onClick}>
          <ListItemText
            primary={isClipboardOrientationEnabled ? "Demo Shift" : "Skills Assessment"}
            secondary={
              isClipboardOrientationEnabled ? (
                <Text variant="caption">
                  Watch a quick virtual walkthrough before you start booking and earning
                </Text>
              ) : null
            }
          />
        </ListItemButton>
      </ListItem>
    </>
  );
}
